import { ThemeLayout } from '../../front/lib/ThemeLayout';
export class SingleCourse extends ThemeLayout {
    constructor() {
        super(...arguments);
        this.iframeEl = this.getElementById('iframe');
    }
    init() {
        window.addEventListener('message', event => {
            var _a;
            if (event.isTrusted && event.source === ((_a = this.iframeEl) === null || _a === void 0 ? void 0 : _a.contentWindow)) {
                const data = JSON.parse(event.data);
                if (data.type === 'resize') {
                    this.iframeEl.style.height = `${data.data.height}px`;
                }
                else if (data.type === 'redirectHere') {
                    const location = data.data.url || this.json.ldCourse.url || '';
                    if (location) {
                        if (data.data.target === '_blank') {
                            const a = document.createElement('a');
                            a.href = location;
                            a.setAttribute('target', '_blank');
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        }
                        else {
                            window.location.href = location;
                        }
                    }
                }
            }
        });
    }
}
